(function () {
  "use strict";

  var t = {
    175: function _(t, i, e) {
      var s = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(i, "__esModule", {
        value: !0
      }), i.Debug = void 0;
      var a = s(e(682)),
          r = e(306),
          o = a.default;
      o.__formatArgs || (o.__formatArgs = o.formatArgs), o.formatArgs = function (t) {
        var i = {
          args: t.concat([]),
          namespace: this.namespace,
          diff: o.humanize(this.diff),
          time: new Date().toISOString()
        };

        try {
          throw new Error("");
        } catch (t) {
          i.stack = t.stack.split("\n"), i.stack.shift(), i.stack.shift(), i.stack.shift(), i.stack = i.stack.map(function (t) {
            return t.trim();
          });
        }

        console.history || (console.history = ["@liquality/debug v" + r.version]), console.history.push(i), o.__formatArgs.call(this, t);
      }, i.Debug = function (t) {
        return o(t = "liquality:cal:" + t);
      };
    },
    306: function _(t) {
      t.exports = JSON.parse('{"name":"@liquality/debug","version":"1.1.1","description":"","module":"dist/index.js","main":"dist/index.js","types":"dist/lib/index.d.ts","directories":{"dist":"dist","src":"lib"},"files":["dist","lib"],"scripts":{"build":"webpack --config ../../webpack/webpack.config.js"},"author":"Liquality <info@liquality.io>","license":"MIT","dependencies":{"@babel/runtime":"^7.12.1","@types/debug":"^4.1.5","debug":"^4.1.1"},"homepage":"https://github.com/liquality/chainabstractionlayer#readme","repository":{"type":"git","url":"git+https://github.com/liquality/chainabstractionlayer.git"},"bugs":{"url":"https://github.com/liquality/chainabstractionlayer/issues"},"publishConfig":{"access":"public"},"sideEffects":false,"gitHead":"3808034cbf70edce84ab68d1a0f86fb91b4c8a1a"}');
    },
    682: function _(t) {
      t.exports = require("debug");
    }
  },
      i = {},
      e = function e(s) {
    var a = i[s];
    if (void 0 !== a) return a.exports;
    var r = i[s] = {
      exports: {}
    };
    return t[s].call(r.exports, r, r.exports, e), r.exports;
  }(175);

  module.exports = e;
})();